import TopFunRankingListCard from 'src/component/screen/topfunrankingtable/TopFunRankingListCard';

type Props = {
  liverId: number;
};

export function TopFunRankingListScreen(props: Props): JSX.Element {
  return <TopFunRankingListCard liverId={props.liverId} />;
}
